import React from "react";
import ChipItem from "./ChipItem";
import { useDispatch, useSelector } from "../app/store";
import { chipsHandlerOnClick } from "../features/chips/chipsSlice";

const Chips = () => {
  const dispatch = useDispatch();
  const { chipsNumber } = useSelector((state) => state.chips);
  const { gameInfo } = useSelector((state) => state.keno);

  const count = 80;
  const groupCount = 10;

  function _getChipsGroups(chipsNumber, viewedNumbers) {
    const chips = new Array(count)?.fill(null)?.map((_, index) => {
      const isActive = Boolean(chipsNumber?.find((chN) => index + 1 === chN));
      const isWin = Boolean(viewedNumbers?.find((chN) => index + 1 === chN));
      return (
        <ChipItem
          key={index + 1}
          number={index + 1}
          onClick={_onClick}
          isActive={isActive}
          isWin={isWin}
        />
      );
    });

    const chipsGroups = new Array(count / groupCount)
      .fill(null)
      .reduce((allGroups, group, index) => {
        const newGroup = (
          <>{chips.slice(groupCount * index, groupCount * (index + 1))}</>
        );
        return [...allGroups, newGroup];
      }, []);
    return chipsGroups;
  }

  function _onClick(number) {
    dispatch(chipsHandlerOnClick(number));
  }

  const chipsGroups = _getChipsGroups(chipsNumber, gameInfo?.viewedNumbers);
  return <div className="chips">{chipsGroups}</div>;
};

export default Chips;
